import { render, staticRenderFns } from "./StatsCardGroup.vue?vue&type=template&id=137f2532"
import script from "./StatsCardGroup.vue?vue&type=script&lang=js"
export * from "./StatsCardGroup.vue?vue&type=script&lang=js"
import style0 from "./StatsCardGroup.vue?vue&type=style&index=0&id=137f2532&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports